import React, { useEffect } from 'react';
import CarCard from '../../CardsWrapper/CarCard';
import './index.css';

export default function ChooseVehicle({
  fromDate,
  fromTime,
  untilDate,
  untilTime,
  filter,
  bookingPeriod,
  deliveryCharge,
  allCars,
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='featured_vehicles'>
      <div className='heading'>Choose a Vehicle</div>
      <div className='featured_card_wrapper'>
        {allCars?.data?.length === 0 ? (
          <div
            style={{
              width: '100%',
              textAlign: 'center',
              fontSize: 22,
            }}
          >
            No Vehicles Available
          </div>
        ) : (
          // _DATA.currentData()

          // .filter((e) => e.vehicle_status === 'prepped')
          allCars?.data?.map((car, index) => (
            <CarCard
              id={car.id}
              key={car.id}
              img={car.car_images[0]?.image}
              title={car.title}
              similarTo={''}
              type={car.type}
              model={car.model}
              make={car.make}
              car={car}
              noOfPeople={car.number_of_seats}
              noOfBags={car.number_of_bags}
              driveTrain={car.drive_train}
              dailyRate={car.daily_price}
              totalCost={car.total_price}
              cardPath={`/car/${car.id}`}
              selectPath={`/info/${car.id}`}
              fromDate={fromDate}
              fromTime={fromTime}
              untilDate={untilDate}
              untilTime={untilTime}
              bookingPeriod={bookingPeriod}
              availabilityBucket={car.search_availability_bucket}
              unavailable={car.unavailable}
              deliveryCharge={deliveryCharge}
            />
          ))
        )}
      </div>
    </div>
  );
}
